"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const UserTransactionType_1 = require("./UserTransactionType");
class UserValidator {
    constructor() {
        this.loginMinLength = 1;
        this.loginMaxLength = 12;
    }
    validate(storedTransactions, tx) {
        const user = tx.model;
        if (user.login.length < 1) {
            throw new Error('Empty login');
        }
        if (user.login.length < this.loginMinLength) {
            throw new Error('Login is too short');
        }
        if (user.login.length > this.loginMaxLength) {
            throw new Error('Login is too long');
        }
        for (const storedTx of storedTransactions) {
            if (storedTx.type !== UserTransactionType_1.UserTransactionType.t) {
                continue;
            }
            const storedUser = storedTx.model;
            if (storedUser.publicKey === user.publicKey) {
                throw new Error('User already registered');
            }
        }
        return new Promise(resolve => resolve());
    }
}
exports.UserValidator = UserValidator;
